import 'react-app-polyfill/ie11';
import 'promise.prototype.finally';

// some specific ES6 features that don't work in older browsers
import 'core-js/features/array/find';
import 'core-js/features/array/includes';

// TODO: consider way to break this up instead of loading entire polyfill?  needed for IE11 to work
import 'core-js/stable';


// trying this to see if fixes for IE
(function () {
  // based on https://github.com/matthew-andrews/Promise.prototype.finally

  // Get a handle on the global object
  let globalObject;
  if (typeof global !== 'undefined') {
    globalObject = global;
  } else if (typeof window !== 'undefined' && window.document) {
    globalObject = window;
  }

  // check if the implementation is available
  if (typeof Promise.prototype['finally'] === 'function') {
    return;
  }

  // implementation
  globalObject.Promise.prototype['finally'] = function (callback) {
    const constructor = this.constructor;

    return this.then(function (value) {
      return constructor.resolve(callback()).then(function () {
        return value;
      });
    }, function (reason) {
      return constructor.resolve(callback()).then(function () {
        throw reason;
      });
    });
  };
}());